import { HotelInboundLinksPropertiesType } from "@website/accommodation-ui/hotel-inbound-links/hotel-inbound-links.types";
import { useMemo } from "react";

export const useHotelInboundLinks = (
  properties: HotelInboundLinksPropertiesType
) => {
  const { list } = properties;

  const masonryList = useMemo(() => {
    const result = [[], [], []];

    if (list) {
      for (const [index, element] of list.entries()) {
        const columnIndex = index % 3;
        result[columnIndex].push(element);
      }
    }
    return result;
  }, [list]);

  return {
    masonryList
  };
};
